import { FunctionComponent } from "react";
import ReactMarkdown, { Components } from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkBreaks from "remark-breaks";
import remarkGfm from "remark-gfm";

export interface IHtmlMarkdownProps {
  children: string;
  className?: string;
  components?: Components | null | undefined;
}

export const HtmlMarkdown: FunctionComponent<IHtmlMarkdownProps> = (props: IHtmlMarkdownProps) => {
  return (
    <div className={props.className}>
      <ReactMarkdown
        remarkPlugins={[remarkBreaks, remarkGfm]}
        rehypePlugins={[rehypeRaw]}
        components={props.components}
      >
        {props.children}
      </ReactMarkdown>
    </div>
  );
};
